
import React, { useState } from "react";
import { useMedicalAssistant } from "@/hooks/use-medical-assistant";
import { ChatInputArea } from "./ChatInputArea";
import { EnhancedChatHeader } from "./EnhancedChatHeader";
import { Message } from "./Message";
import { useIsMobile } from "@/hooks/use-mobile";
import { ScrollArea } from "@/components/ui/scroll-area";

export const EnhancedChatWindow: React.FC = () => {
  const [input, setInput] = useState("");
  const isMobile = useIsMobile();

  const {
    messages,
    isLoading,
    isRecording,
    isProcessingAudio,
    isSpeaking,
    selectedImage,
    imageUrl,
    currentLanguage,
    continuousMode,
    autoVoiceResponse,
    voiceOnlyMode,
    modalOpen,
    imageAnalysisMode,
    handleSubmit,
    reset,
    handleImageChange,
    setImageUrl,
    startRecording,
    stopRecording,
    stopRecordingAndSubmit,
    saveVoiceRecording,
    setCurrentLanguage,
    setContinuousMode,
    setAutoVoiceResponse,
    setVoiceOnlyMode,
    toggleVoiceModal,
    setImageAnalysisMode,
    stopAudio
  } = useMedicalAssistant();

  const clearSelectedImage = () => {
    handleImageChange(null);
    setImageUrl(null);
  };

  return (
    <div className="flex flex-col h-[600px] bg-white rounded-lg shadow-sm border border-blue-100">
      <EnhancedChatHeader
        onReset={reset}
        currentLanguage={currentLanguage}
        onLanguageChange={setCurrentLanguage}
        continuousMode={continuousMode}
        onContinuousModeChange={setContinuousMode}
        autoVoiceResponse={autoVoiceResponse}
        onAutoVoiceResponseChange={setAutoVoiceResponse}
        voiceOnlyMode={voiceOnlyMode}
        onVoiceOnlyModeChange={setVoiceOnlyMode}
      />
      
      <ScrollArea className="flex-1 p-4">
        <div className="flex flex-col space-y-4">
          {messages.map((message) => (
            <Message
              key={message.id}
              message={message}
              voiceOnlyMode={voiceOnlyMode}
            />
          ))}
        </div>
      </ScrollArea>
      
      <ChatInputArea
        input={input}
        setInput={setInput}
        handleFormSubmit={handleSubmit}
        isLoading={isLoading}
        isRecording={isRecording}
        isProcessingAudio={isProcessingAudio}
        isSpeaking={isSpeaking}
        startRecording={startRecording}
        stopRecording={stopRecording}
        stopRecordingAndSubmit={stopRecordingAndSubmit}
        saveVoiceRecording={saveVoiceRecording}
        selectedImage={selectedImage}
        previewUrl={imageUrl}
        clearImage={clearSelectedImage}
        handleImageChange={handleImageChange}
        currentLanguage={currentLanguage}
        messages={messages}
        modalOpen={modalOpen}
        toggleVoiceModal={toggleVoiceModal}
        continuousMode={continuousMode}
        autoVoiceResponse={autoVoiceResponse}
        voiceOnlyMode={voiceOnlyMode}
      />
    </div>
  );
};
